







import {Component} from 'vue-property-decorator'
import axios from 'axios'
import { apiV1AdminEventPagePath } from '@/rails/routes'
import EventPage, {IEventPage} from '@/models/EventPage'
import EventPageForm from '@/components/admin/event_pages/Form.vue'
import PageBase, {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    EventPageForm
  }
})
export default class EventPageEdit extends PageBase {
  eventPage = new EventPage()

  async mounted(): Promise<void> {
    try {
      super.mounted()
      const res = await axios.get<IEventPage>(apiV1AdminEventPagePath(this.$route.params.id))
      this.eventPage = new EventPage(res.data)
      this.loading = false
    } catch (e) {
      console.error(e)
    }
  }

  async save(): Promise<void> {
    try {
      const res = await axios.put(apiV1AdminEventPagePath(this.$route.params.id), {
        event_page: this.eventPage.toParams()
      })
      this.eventPage = new EventPage(res.data)
      this.showMessage('変更を保存しました。')
      this.$router.push(`/admin/event_pages/${this.eventPage.id}/edit`)
    } catch (e) {
      console.log(e)
    }
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'イベントページ一覧',
        to: '/admin/event_pages',
        exact: true
      },
      {
        text: 'イベントページ編集'
      }
    ]
  }
}
